var firefoxVersion = (function() {
  var ua = navigator.userAgent;
  var version = null;

  if (/Firefox\//.test(ua)) {
    version = parseFloat(/Firefox\/([0-9\.A-z]+)/.exec(ua)[1]);
  }
  return version;
})();

export { firefoxVersion };
